import { Link } from "react-router";
import type { LinkProps } from "../shell/link";

const EXTERNAL = /^(?:[a-z][a-z\d+.-]*:|\/\/)/i;

/** React Router adapter for `<LinkProvider component={RouterLink}>`; external and hash links stay native. */
export function RouterLink({ href, children, ...rest }: LinkProps) {
  if (EXTERNAL.test(href) || href.startsWith("#")) {
    return (
      <a href={href} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={href} {...rest}>
      {children}
    </Link>
  );
}
